/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts() {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */'webfontloader')

  webFontLoader.load({
    // Fonts are now loaded locally via CSS imports in main.js
    // google: {
    //   families: ['Roboto:100,300,400,500,700,900&display=swap'],
    // },
  })
}
